import React from "react";
import { useState, useEffect, useCallback, useMemo } from "react";
import apiInstance from "../Utils/api";
export const useGetList = (endpoint, immediate = true, params = {}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const fetchData = useCallback(
    async (customParams) => {
      setLoading(true);
      setError(null);

      try {
        const response = await apiInstance.get(endpoint, {
          params: { ...params, ...customParams },
        });
        // setData(response?.data?.list || response?.data?.data || response?.data);
        setData(response.data);

        // Update pagination if available

        return response.data;
      } catch (err) {
        const errorMessage =
          err.response?.data?.message ||
          err.message ||
          "An error occurred while fetching data";
        setError(errorMessage);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [endpoint],
  );

  const refetch = useCallback(() => {
    return fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (immediate) {
      fetchData();
    }
  }, [immediate, fetchData]);

  return {
    data,
    loading,
    error,
    refetch,
    fetchData,
  };
};
